module.exports = __webpack_public_path__ + "static/media/commerce.6ffb2429.png";